import React, { useMemo, useState } from 'react';
import './ContactForm.css';
import { serviceCatalog } from '../data/serviceCatalog';
import { buildMailtoHref } from '../utils/contactHelpers';
import { useLanguage } from '../context/LanguageContext';

const ContactForm = ({ service }) => {
  const { t, lang } = useLanguage();
  const [formData, setFormData] = useState({
    serviceSlug: service ? service.slug : serviceCatalog[0].slug,
    name: '',
    company: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const selectedService = useMemo(
    () => service || serviceCatalog.find((item) => item.slug === formData.serviceSlug) || serviceCatalog[0],
    [service, formData.serviceSlug]
  );

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    window.location.href = buildMailtoHref(selectedService, formData, lang);
  };

  return (
    <section className="section-tight">
      <div className="container contact-layout">
        <div className="contact-panel">
          <div className="eyebrow">Innovative Horizons</div>
          <h2>{t.contact.formTitle}</h2>
          <p>{t.contact.formSubtitle}</p>
          <form onSubmit={handleSubmit}>
            {!service && (
              <div className="form-row">
                <div className="field full-width">
                  <label>{t.contact.service}</label>
                  <select name="serviceSlug" value={formData.serviceSlug} onChange={handleChange} className="contact-select">
                    {serviceCatalog.map((item) => (
                      <option key={item.slug} value={item.slug}>
                        {item.title[lang]}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            )}

            <div className="form-row two-col">
              <div className="field">
                <label>{t.contact.name}</label>
                <input type="text" name="name" placeholder={t.contact.namePlaceholder} value={formData.name} onChange={handleChange} required />
              </div>
              <div className="field">
                <label>{t.contact.company}</label>
                <input type="text" name="company" placeholder={t.contact.companyPlaceholder} value={formData.company} onChange={handleChange} />
              </div>
            </div>

            <div className="form-row two-col">
              <div className="field">
                <label>{t.contact.email}</label>
                <input type="email" name="email" placeholder={t.contact.emailPlaceholder} value={formData.email} onChange={handleChange} required />
              </div>
              <div className="field">
                <label>{t.contact.phone}</label>
                <input type="tel" name="phone" placeholder={t.contact.phonePlaceholder} value={formData.phone} onChange={handleChange} />
              </div>
            </div>

            <div className="form-row">
              <div className="field full-width">
                <label>{t.contact.subject}</label>
                <input type="text" name="subject" placeholder={t.contact.subjectPlaceholder} value={formData.subject} onChange={handleChange} />
              </div>
            </div>

            <div className="form-row">
              <div className="field full-width">
                <label>{t.contact.message}</label>
                <textarea name="message" rows="6" placeholder={t.contact.messagePlaceholder} value={formData.message} onChange={handleChange} required />
              </div>
            </div>

            <button className="contact-submit" type="submit">{t.contact.submit}</button>
          </form>
        </div>

        <aside className="contact-aside">
          <div className="eyebrow">{selectedService.title[lang]}</div>
          <h3>{t.contact.asideTitle}</h3>
          <p>{selectedService.desc[lang]}</p>
          <ul className="check-list">
            {t.contact.asidePoints.map((item) => <li key={item}>{item}</li>)}
          </ul>
          <div className="contact-highlight">
            <span>{selectedService.email}</span>
          </div>
        </aside>
      </div>
    </section>
  );
};

export default ContactForm;
